import { notBlank, notUndefined } from './Assert';

class EnvironmentUtil {
  private readonly environments: Environments;

  constructor(environments: Environments) {
    notUndefined(environments, 'Environments cannot be undefined');
    notUndefined(environments.keycloakUrl, 'Keycloak url cannot be undefined');
    notUndefined(environments.transactionUrl, 'Transaction url cannot be undefined');
    notBlank(environments.transactionUrl, 'Transaction url cannot be undefined');
    notBlank(environments.keycloakUrl, 'Keycloak url cannot be blank');
    this.environments = environments;
  }

  public getKeycloakUrl() {
    return this.environments.keycloakUrl;
  }

  public getTransactionUrl() {
    return this.environments.transactionUrl;
  }

  public getWatchlist() {
    return this.environments.watchlist;
  }

  public getCra() {
   return this.environments.cra;
  }

  public getAch() {
    return this.environments.ach;
  }

  public getAiModel() {
    return this.environments.aiModel;
  }

  public getTracker() {
    return this.environments.tracker;
  }

  public isLdapOnly() {
    return this.environments.ldapOnly;
  }

  public isPageChange() {
    return this.environments.pageChange;
  }

  public isMouseTrack() {
    return this.environments.mouseTrack;
  }

  public expressionInputEnabled() {
    return this.environments.expressionInputEnabled ?? false;
  }

  public isAuditLogVisible() {
    return this.environments.auditLogVisible;
  }

  public getPages() {
    return this.environments.page;
  }

  public getUserActiveCheckMs() {
    return this.environments.userActiveCheckMs;
  }

  public getStorageMaxSize(): number {
    return this.environments.storageMaxSize ?? 50 * 1024 * 1024;
  }
}

export interface Environments {
  keycloakUrl: string;
  transactionUrl: string;
  ldapOnly: boolean;
  pageChange: boolean;
  mouseTrack: boolean;
  watchlist: boolean;
  cra: boolean;
  ach: boolean;
  aiModel: boolean;
  tracker: boolean;
  expressionInputEnabled: boolean;
  auditLogVisible: boolean;
  page: {
    sandbox: boolean;
    entity: boolean;
    historicalSandbox: boolean;
  };
  userActiveCheckMs: number;
  storageMaxSize?: number;
}

export default EnvironmentUtil;
